<div class="container">
  <!-- menu-1 -->
  <div>
    <ul id="menu-1" ui-menu uiMode="inline" (uiClick)="clickOnItem($event)">
      <li id="submenu-1" ui-submenu uiTitle="Navigation One" uiIcon="mail" uiOpen>
        <ul>
          <li id="menu-group-1" ui-menu-group uiTitle="Group 1">
            <ul>
              <li ui-menu-item uiSelected>Item 1</li>
              <li id="menu-item-to-select" ui-menu-item>Item 2</li>
            </ul>
          </li>
          <li id="menu-group-2" ui-menu-group uiTitle="Group 2">
            <ul>
              <li ui-menu-item>Item 3</li>
              <li ui-menu-item uiDanger>Item 4</li>
            </ul>
          </li>
        </ul>
      </li>
      <li id="submenu-2" ui-submenu uiTitle="Navigation Two" uiIcon="appstore" (uiOpenChange)="clickOnSubmenu($event)" uiClassName="sp-p-2">
        <ul>
          <li ui-menu-item>Item 5</li>
          <li ui-menu-item>Item 6</li>
          <li ui-submenu uiTitle="Submenu">
            <ul>
              <li ui-menu-item>Item 7</li>
              <li ui-menu-item>Item 8</li>
              <li ui-submenu uiTitle="Submenu">
                <ul>
                  <li ui-menu-item uiDisabled>Item 9</li>
                  <li ui-menu-item>Item 10</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li ui-submenu uiTitle="Navigation Three" uiIcon="setting">
        <ul>
          <li ui-menu-item>Item 11</li>
          <li ui-menu-item>Item 12</li>
          <li ui-menu-item>Item 13</li>
        </ul>
      </li>
      <li id="submenu-4" ui-submenu uiTitle="Navigation Four" uiIcon="close" (uiOpenChange)="clickOnSubmenu($event)" uiDisabled>
        <ul>
          <li ui-menu-item>There is no item here!</li>
        </ul>
      </li>
    </ul>
  </div>
  <!-- menu-2 -->
  <div>
    Change theme <ui-toggle id="theme-toggle" [(ngModel)]="toggleTheme"></ui-toggle> Change mode <ui-toggle id="mode-toggle" [(ngModel)]="mode"></ui-toggle>
    <ul id="menu-2" ui-menu [uiMode]="mode ? 'vertical' : 'inline'" [uiTheme]="toggleTheme ? 'dark' : 'light'" class="sp-mt-10">
      <li ui-submenu uiTitle="Navigation Three - Submenu" uiIcon="setting">
        <ul>
          <li id="menu-group-2-1" ui-menu-group>
            <p title>This is template title</p>
            <ul>
              <li ui-menu-item>Item 1</li>
              <li ui-menu-item>Item 2</li>
            </ul>
          </li>
          <li ui-menu-group uiTitle="Group 2">
            <ul>
              <li ui-menu-item>Item 3</li>
              <li ui-menu-item>Item 4</li>
              <li ui-submenu uiTitle="Sub Menu">
                <ul>
                  <li ui-menu-item uiDisabled>Item 5</li>
                  <li ui-menu-item>Item 6</li>
                </ul>
              </li>
              <li ui-submenu uiDisabled uiTitle="Disabled Sub Menu">
                <ul>
                  <li ui-menu-item>Item 5</li>
                  <li ui-menu-item>Item 6</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
